module.exports = __webpack_public_path__ + "static/img/ljqs.be17538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/ljqs.png
// module id = IMic
// module chunks = 0